import { t } from "i18next"
import { DataTable, Number } from "components/common"
import { useMemo } from "react"
import { localisedValue } from "utils"
const InvoicedUnits = ({ data }) => {
  const dataColumns = useMemo(
    () => [
      { title: t("Unit no"), dataIndex: "unit", key: "unit" },
      { title: t("Client"), dataIndex: "client", key: "client" },
      { title: t("Deal Price"), dataIndex: "dealprice", key: "dealprice" },
    ],
    [data]
  )
  const dataTable = useMemo(
    () =>
      data
        ? data.map((e, index) => ({
            key: index,
            unit: e?.unitNo,
            client: localisedValue({ object: e, key: "clientName" }),
            dealprice: <Number value={e?.dealPrice} isCurrency={true} compact="" digitAfterFraction={2} />,
          }))
        : [],
    [data]
  )
  return (
    <div style={{ paddingTop: 12 }}>
      {!!dataTable?.length && (
        <>
          <DataTable tableLayout="auto" columns={dataColumns} data={dataTable} stickyOffset={-16} />
        </>
      )}
    </div>
  )
}

export default InvoicedUnits
